import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import dayjs from 'dayjs';
import { programBoardList } from '@/network/apis/apiUri';
import { BOARD_CONFIG } from '@/config';
import { increaseDetailHitCount } from '@/util';

const BANNER_COOKIE_NAME = 'a_b';

export default function TopBanner() {
  const location = useLocation();

  const { mode } = useSelector((state) => state);

  const isHome = location.pathname === '/';

  const [bannerOpen, setBannerOpen] = useState(document.cookie.includes(BANNER_COOKIE_NAME));

  const { isSuccess, data: topBannerList } = useQuery({
    queryKey: ['home', 'banner', mode, BOARD_CONFIG.HOME_TOP_BANNER],
    queryFn: async () => {
      const response = await programBoardList({
        lan_code: mode,
        title: '',
        board_id: BOARD_CONFIG.HOME_TOP_BANNER.id,
        content_category: '',
        event_category: null,
        is_open_allow: true,
        is_blind_allow: false,
        is_content: true,
        page_info: { row_count: -1, number: 0 },
      });

      const checkAllow = (ct) => {
        if (mode === 'ko' && ct === '1') return false;
        if (mode === 'en' && ct === '2') return false;
        return true;
      };
      const filteredList = response.data.item.filter((item) => checkAllow(item.content));

      return filteredList.map((item) => ({
        boardItemId: item.board_item_id,
        title: item?.title || '',
        image: item.image?.url || '',
        link: item.url_link?.[0]?.trim() || '',
      }));
    },
    staleTime: Infinity,
    retry: false,
    enabled: !bannerOpen,
  });

  const setCookie = () => {
    const expireDate = dayjs().add(3, 'day').utc().toString();

    document.cookie = BANNER_COOKIE_NAME.concat('=', expireDate, ';', 'expires=', expireDate);
  };

  const handleBannerClose = (e) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);

    const isCheck = formData.get('setting');

    if (isCheck) setCookie();

    setBannerOpen(true);
  };

  const isBannerOpen = isHome && !bannerOpen && isSuccess && topBannerList.length > 0;

  return (
    <div className="top-banner-container">
      <div className="gov">
        <div className="gov__content">
          <img src={require('@/assets/images/layout/korea.svg').default} alt="korea taegeukgi" />
          <p>This website is the official e-government website of the Republic of Korea</p>
        </div>
      </div>
      {isBannerOpen && (
        <div className="banner">
          <Swiper slidesPerView={1} autoplay={{ delay: 5000 }} enabled={topBannerList.length > 1}>
            {topBannerList.map((v, i) => (
              <SwiperSlide key={v.boardItemId}>
                {!!v.link ? (
                  <a
                    href={v.link}
                    target="_blank"
                    rel="noreferrer"
                    className="banner__item"
                    title={`${v.title} - Opens in a new window`}
                    onClick={() => increaseDetailHitCount(v.boardItemId)}
                    tabIndex={0}
                  >
                    <img src={v.image} alt={v.title} height={80} />
                    <form onSubmit={handleBannerClose} className="banner__close-box">
                      <label>
                        {mode === 'en' ? 'Not seen for 3 days' : '3일 동안 보지 않기'}
                        <input type="checkbox" name="setting" />
                      </label>
                      <button type="submit" value="close btn" />
                    </form>
                  </a>
                ) : (
                  <>
                    <img src={v.image} alt={v.title} height={80} />
                    <form onSubmit={handleBannerClose} className="banner__close-box">
                      <label>
                        {mode === 'en' ? 'Not seen for 3 days' : '3일 동안 보지 않기'}
                        <input type="checkbox" name="setting" />
                      </label>
                      <button type="submit" value="close btn" />
                    </form>
                  </>
                )}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </div>
  );
}
